/**
 * Ryan O'Dowd
 * 2022-08-05
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import FollowButton from '@components/FollowButton';
import ListItem from '@components/ListItem';
import {
  PROFILE_ROUTE,
} from '@utils/store/actions';
import Photo from '@components/Photo';
import React from 'react';
import Text from '@components/common/Text';
import {
  View,
} from 'react-native';
import {
  format as dateFnsFormat,
} from 'date-fns';
import getStyles from './styles';
import hooks from '@hooks';

const User = (props: UserProps) => {
  const i18n = hooks.useI18n();
  const navigation = hooks.useNavigation();
  const styles = hooks.useStyles(getStyles, {isDense: props.dense});

  const _renderStat = (label, value) => {
    return (
      <View style={styles.statWrapper}>
        <Text style={styles.statLabel}>{label}: </Text>
        <View style={styles.statValueWrapper}>
          <Text style={styles.statValue}>{value}</Text>
        </View>
      </View>
    );
  };

  return (
    <ListItem
      containerStyles={[styles.container, props.dense && styles.denseContainer]}
      innerStyles={props.dense && styles.listItemInner}
      onPress={() => navigation.navigate(PROFILE_ROUTE, {otherUserId: props.id})}// @TODO: i think it's okay to expose ids here?
    >
      <View style={styles.photosAndNamesRow}>
        <View style={styles.profilePicture}>
          <Photo
            style={styles.profilePicture}
            readOnly={true}
            imageStyle={styles.imageStyles}
            displayName={props.display_name}
            username={props.username}
            lastActive={props.last_active}
            badgeSize={props.dense ? 14 : 16}
          />
        </View>
        <View style={styles.namesWrapper}>
          <Text style={styles.displayName}>{props.display_name}</Text>
          {!props.dense && <Text style={styles.username}>{props.username}</Text>}
          {/* @TODO:
          {props.dense && <Text style={styles.dailyPeanutCount}>{`123 ${i18n('peanutsLowercase')} today`}</Text>}{/* @TODO: don't hardcode
          */}
          {/* @TODO: make sure that long names still look okay with the button here */}
          {!props.isFollowing && // @TODO: and not blocked
            <View style={styles.followButtonWrapper}>
              <FollowButton userIdToFollow={props.id} />
            </View>
          }
        </View>
      </View>
      {!props.dense &&
        <React.Fragment>
          {!(!props.streak_num && !props.lifetime_wrinkles && !props.lifetime_peanuts) &&
            <View style={styles.stats}>
              {_renderStat(i18n('streak'), props.streak_num)}
              {_renderStat(i18n('wrinkles'), props.lifetime_wrinkles)}
              {_renderStat(i18n('peanuts'), props.lifetime_peanuts)}
            </View>
          }
          <Text style={styles.wrinklingSince}>{i18n('wrinklingSince', dateFnsFormat(new Date(props.created_at), 'MMMM yyyy', {locale: i18n.dateFnsLocale}))}</Text>
        </React.Fragment>
      }
      {/* @TODO: if not already following this user, have button to add them */}
      {/* @TODO: if both following each other (or maybe just one way?), have option to challege the person to a lesson (if online right now?) */}
    </ListItem>
  );
};

class UserProps {
  id: number;
  display_name: string;
  username: string;
  streak_num: number;
  last_active: string | 0;
  created_at: string;
  isFollowing: boolean;

  dense?: boolean;
  lifetime_wrinkles?: number;
  lifetime_peanuts?: number;
};

export default User;
